import { allIntegrations } from "./integrations"
import { IntegrationAuthType } from "./types"

interface IntegrationAuthContext {
  username: string
  data?: Record<string, unknown>
}

export function getIntegrationAuthType(
  name: string,
  integration?: IntegrationAuthContext
): IntegrationAuthType {
  const config = allIntegrations.find(i => i.id === name)
  if (config?.authType) {
    return config.authType
  }
  if (!integration) {
    return "other"
  }
  if (integration.username !== "NEEDS_USERNAME") {
    return "password"
  }
  if (typeof integration.data?.email_from === "string" && integration.data.email_from.trim()) {
    return "email"
  }
  return "other"
}

export type OauthProvider = "gmail" | "microsoft" | "sageintacct" | "xero" | "quickbooks" | "googledrive"

const OAUTH_PROVIDER_BY_INTEGRATION: Record<string, OauthProvider> = {
  gmail: "gmail",
  microsoft: "microsoft",
  quickbooks: "quickbooks",
  xero: "xero",
  sageintacct: "sageintacct",
  googledrive: "googledrive",
}

export function getOauthProviderForIntegration(name: string): OauthProvider | null {
  return OAUTH_PROVIDER_BY_INTEGRATION[name] ?? null
}

export function isKnownIntegrationName(name: string): boolean {
  return allIntegrations.some(i => i.id === name)
}
